import React, { useEffect, useState } from "react";
import BreadCrumb from "../components/BreadCrumb";
import Meta from "../components/Meta";
import BlogCard from "../components/BlogCard";
import Container from "../components/Container";
import { useDispatch, useSelector } from "react-redux";
import { getAllBlogs } from "../features/blogs/blogSlice";
import moment from "moment";
 

const Blog = () => {
  const blogState = useSelector((state) => state?.blog?.blog);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getblogs();
  }, []);

  const getblogs = async () => {
    setLoading(true);
    await dispatch(getAllBlogs());
    setLoading(false);
  };

  return (
    <>
      <Meta title={"Blogs"} />
      <BreadCrumb title="Blogs" />
      <Container class1="blog-wrapper home-wrapper-2 py-5">
        <div className="row blog-container">
          {loading
            ? [...Array(4)].map((_, index) => (
                <div className="col-6 mb-3" key={index}>
                  <BlogCard loading={true} />
                </div>
              ))
            : blogState?.map((item, index) => (
                <div className="col-6 mb-3" key={index}>
                  <BlogCard
                    id={item?._id}
                    title={item?.title}
                    description={item?.description}
                    image={item?.images[0]?.url}
                    date={moment(item?.createdAt).format("MMMM Do YYYY")}
                    loading={false}
                  />
                </div>
              ))}
        </div>
      </Container>
    </>
  );
};

export default Blog;
